@if (nextScheduledProcessingDate()) {
  <div class="mb-5 text-right text-sm text-gray-500">
    <div>Najbliższe automatyczne przetwarzanie subskrypcji:</div>
    <div><app-date-time [date]="nextScheduledProcessingDate()!" /></div>

    @if (soldBox()) {
      <div>Aktualny box w sprzedaży: <strong>{{ soldBox() }}</strong></div>
    }
  </div>
}

<app-action-buttons [actions]="actions()" />
